<script>
  // @ts-check
  import EventPreviewList from "$lib/components/EventPreviewList.svelte";
  import { transformListItems } from "$lib/utilities/contentTypes/eventPreviewList";
  import { getContext } from "svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  export let data;
  const epl = getContext("epls")?.[data.sys.id] || /** for backward compatibility */ data;
  const itemsData = epl?.fields.listItems || [];
  const themedItems = epl?.fields?.themedItems ?? [];
  const featuredItems = epl?.fields?.featuredItems ?? [];
  const excludedItems = epl?.fields?.excludedItems ?? [];
  const maxItems = epl?.fields?.maxItems || 4;
  const showMonth = !!epl?.fields?.showMonth;
  const formFactor = epl?.fields?.formFactor || "Calendar Grid";
  const isToursEPL = epl?.fields?.typeFilter?.every((type) => type === "Tour");
  // not currently a fields on contentful EPL, used by event detail page:
  const title = epl?.fields?.displayTitle;
  const cta = epl?.fields?.cta || null;

  // TODO: send in start/end of epl
  const transformedItems = transformListItems({
    items: itemsData,
    themedItems,
    featuredItems,
    excludedItems,
    showMonth,
    maxItems,
    formFactor
  });
</script>

<EventPreviewList
  id={data.sys?.id}
  {title}
  class={className}
  items={transformedItems.items || []}
  featuredItems={transformedItems.featuredItems || []}
  days={transformedItems.days || []}
  {isToursEPL}
  {formFactor}
  {cta}
/>
